import script from "./backgroundRecharge.vue?vue&type=script&setup=true&lang=ts"
export * from "./backgroundRecharge.vue?vue&type=script&setup=true&lang=ts"

import "./backgroundRecharge.vue?vue&type=style&index=0&id=dfb7fb9e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfb7fb9e"]])

export default __exports__